import { useSelector } from 'react-redux';

// True only when the school has connected Google Drive; every document or
// file-upload surface must be hidden while this is false.
export const useGoogleDrive = () =>
  useSelector((s) => Boolean(s?.user?.googleDriveConnected));
